import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

export const networkErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBar = inject(MatSnackBar);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (!navigator.onLine || error.status === 0) {
        snackBar.open(
          'Nincs internetkapcsolat. Kérjük, ellenőrizd a hálózati beállításokat.',
          'Bezár',
          {
            duration: 0, // Marad a képernyőn amíg be nem zárják
            panelClass: ['error-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'top'
          }
        );
      }
      return throwError(() => error);
    })
  );
};
